
import * as d3 from 'd3'
export default {

  methods: {

    popup_MenuItem(selection, _menu) {

      let data = this.dataSet.filter(f=> f.PHASE == _menu.PHASE && f.GROUP == _menu.GROUP && f.ITEM == _menu.ITEM)

      // TitleBar
      let address = [_menu.PHASE, _menu.GROUP, _menu.ITEM]
      
      let modalCanvas = selection
      .append('g')
      .attr('id', `MODAL_ITEM`)
      .attr('transform', `translate(20.5, 70.5)`)

      modalCanvas
      .append('text')
      .attr('x', -10).attr('y', -50)
      .attr('font-size', 11).attr('fill', '#000')
      .text(`${_menu.PHASE} > ${_menu.GROUP} > ${_menu.ITEM}`)

      // Header
      modalCanvas
      .append('rect')
      .attr('x', 0).attr('y', -16)
      .attr('width', this.menuItem.columns[3].ex).attr('height', 28)
      .attr('fill', `url(#${this.localId}_LightBlue_)`).attr('opacity', .4)

      modalCanvas
      .append('rect')
      .attr('x', 0).attr('y', -16)
      .attr('width', this.menuItem.width).attr('height', 28)
      .attr('fill', `url(#${this.localId}_LightBlue_)`).attr('opacity', .3)

      this.gmx_Line(modalCanvas, 0, this.menuItem.width, -17, -17, '#999', .5, 1)
      this.gmx_Line(modalCanvas, 0, this.menuItem.width, 13, 13, '#999', .5, 1)

      this.gmx_Text(modalCanvas, '', this.menuItem.columns[6].ex, -5,  9, '#000','middle', '', 'WorkOrder Status')

      this.menuItem.columns.forEach(d=> {
        modalCanvas
        .append('text')
        .attr('x', d.mx)
        .attr('y', d.group ? 2 : 8)
        .attr('font-size', d.group ? 10 : 8.5)
        .attr('text-anchor', 'middle')
        .attr('fill', d.group ? '#000' : '#333')
        .text(d.name)

        this.gmx_Line(modalCanvas, d.ex, d.ex, d.group ? -13 : 2, 9, '#757575', .5, .5)
        this.gmx_Line(modalCanvas, d.ex+1, d.ex+1, d.group ? -13 : 2, 9, '#fff', .5, .5)
      })

      // WorkOrder List
      let _y = 31
      data.forEach((d,i)=> {

        let woItem = modalCanvas
        .append('g')
        .attr('transform', `translate(0, ${_y})`)
        .attr('cursor', 'pointer')
        .on('mouseover', ()=> {
          d3.select(`#WO_${i}`).transition().duration(75).attr('opacity', .2)
        })
        .on('mouseout', ()=> {
          d3.select(`#WO_${i}`).transition().duration(250).attr('opacity', 0)
        })
        .on('click', ()=> {
          d3.select(`#MODAL_ITEM`).remove()
          this.popup_WorkOrder(selection, d, _menu)
        })
        
        woItem
        .append('rect')
        .attr('id', `WO_${i}`)
        .attr('x', 0).attr('y', -16)
        .attr('width', this.menuItem.width).attr('height', 26)
        .attr('fill', `#bcbcbc`).attr('opacity', 0)

        this.menuItem.columns.forEach(col=> {
          if(col.type == 'icon' && d.INCHARGE) {
            woItem
            .append('image')
            .attr('xlink:href', require(`../../../../../src/assets/avatar/${d.INCHARGE ? d.INCHARGE : 'default'}.png`))
            .attr('x', col.mx-12).attr('y', -15).attr('width', 24)
          } else if(col.type == 'title' && d.COMMENTS > 0) {
            woItem
            .append('text')
            .attr('id', `TITLE_${d.IDX}`)
            .attr('x', col.tx).attr('y', 0)
            .attr('font-size', 10).attr('text-anchor', col.align).attr('fill', '#333')
            .text(`${d[col.code]}`)

            woItem
            .append('text')
            .attr('x', col.tx + this.getNode( `#TITLE_${d.IDX}`) + 2).attr('y', 0)
            .attr('font-size', 10).attr('text-anchor', col.align).attr('fill', '#44A9DF')
            .text(`(${d.COMMENTS})`)
          } else {
            woItem
            .append('text')
            .attr('x', col.tx).attr('y', 0)
            .attr('font-size', 10).attr('text-anchor', col.align)
            .attr('fill', col.type == 'status' ? this.status.find(f=> f.name == d.STATUS).tColor : '#333')
            .text(col.type == 'date' && d[col.code] ? this.gmx_changeDate('/', d[col.code]) : d[col.code])
          }
        })
        
        this.gmx_Line(woItem, 0, this.menuItem.width, 12, 12, '#bcbcbc', .5, .5)

        _y += 30
      })

    },

  }
}